import {
	BANNER_FETCH,
	BANNER_FETCH_SUCESS,
	BANNER_FETCH_FAIL,

	BANNER_DETAIL_FETCH,
	BANNER_DETAIL_FETCH_SUCESS,
	BANNER_DETAIL_FETCH_FAIL,

	CATEGORY_FETCH,
	CATEGORY_FETCH_SUCESS,
	CATEGORY_FETCH_FAIL,

	PROGRAM_DETAIL_FETCH,
	PROGRAM_DETAIL_FETCH_SUCESS,
	PROGRAM_DETAIL_FETCH_FAIL,

	FAVORITE_SEND_FETCH,
	FAVORITE_SEND_FETCH_SUCESS,
	FAVORITE_SEND_FETCH_FAIL,

	SEARCH_FETCH,
	SEARCH_FETCH_SUCESS,
	SEARCH_FETCH_FAIL,

	ALL_PROGRAM_FETCH,
	ALL_PROGRAM_FETCH_SUCCESS,
	ALL_PROGRAM_FETCH_FAIL,

	PROGRAM_PLAY_FETCH,
	PROGRAM_PLAY_FETCH_SUCCESS,
	PROGRAM_PLAY_FETCH_FAIL,

	LIVE_FETCH,
	LIVE_FETCH_SUCCESS,
	LIVE_FETCH_FAIL,

	OLD_GROUP,

	CURRENT_PLAY_FETCH,
	CURRENT_PLAY_FETCH_SUCCESS,
	CURRENT_PLAY_FETCH_FAIL,


	PROGRAM_DETAIL_PREVIEW_FETCH,
	PROGRAM_DETAIL_PREVIEW_FETCH_SUCESS,
	PROGRAM_DETAIL_PREVIEW_FETCH_FAIL,

	SHARE_FETCH,
	SHARE_FETCH_SUCESS,
	SHARE_FETCH_FAIL,


	CLICK_SHARE_FETCH,
	CLICK_SHARE_FETCH_SUCESS,
	CLICK_SHARE_FETCH_FAIL,

} from '../actions';

/* banner */
export const bannerFetch = (banner) => ({
	type: BANNER_FETCH,
	payload: { banner }
});

export const bannerFetchSuccess = (banner) => ({
	type: BANNER_FETCH_SUCESS,
	payload: { banner }
});

export const bannerFetchFail = (message) => ({
	type: BANNER_FETCH_FAIL,
	payload: { message }
});

/* banner detail */
export const bannerDetailFetch = (bannerDetail) => ({
	type: BANNER_DETAIL_FETCH,
	payload: { bannerDetail }
});

export const bannerDetailFetchSuccess = (bannerDetail) => ({
	type: BANNER_DETAIL_FETCH_SUCESS,
	payload: { bannerDetail }
});

export const bannerDetailFetchFail = (message) => ({
	type: BANNER_DETAIL_FETCH_FAIL,
	payload: { message }
});

/* category */
export const categoryFetch = (category) => ({
	type: CATEGORY_FETCH,
	payload: { category }
});

export const categoryFetchSuccess = (category) => ({
	type: CATEGORY_FETCH_SUCESS,
	payload: { category }
});

export const categoryFetchFail = (message) => ({
	type: CATEGORY_FETCH_FAIL,
	payload: { message }
});

/* program detail */
export const programDetailFetch = (programDetail) => ({
	type: PROGRAM_DETAIL_FETCH,
	payload: { programDetail }
});

export const programDetailFetchSuccess = (programDetail) => ({
	type: PROGRAM_DETAIL_FETCH_SUCESS,
	payload: { programDetail }
});

export const programDetailFetchFail = (message) => ({
	type: PROGRAM_DETAIL_FETCH_FAIL,
	payload: { message }
});

/* favorite send */
export const favoriteSendFetch = (favoriteSend) => ({
	type: FAVORITE_SEND_FETCH,
	payload: { favoriteSend }
});

export const favoriteSendFetchSuccess = (favoriteSend) => ({
	type: FAVORITE_SEND_FETCH_SUCESS,
	payload: { favoriteSend }
});

export const favoriteSendFetchFail = (message) => ({
	type: FAVORITE_SEND_FETCH_FAIL,
	payload: { message }
});

/* search */
export const searchFetch = (search) => ({
	type: SEARCH_FETCH,
	payload: { search }
});

export const searchFetchSuccess = (search) => ({
	type: SEARCH_FETCH_SUCESS,
	payload: { search }
});

export const searchFetchFail = (message) => ({
	type: SEARCH_FETCH_FAIL,
	payload: { message }
});

/* all Program */
export const allProgramFetch = (allProgram) => ({
	type: ALL_PROGRAM_FETCH,
	payload: { allProgram }
});

export const allProgramFetchSuccess = (allProgram) => ({
	type: ALL_PROGRAM_FETCH_SUCCESS,
	payload: { allProgram }
});

export const allProgramFetchFail = (message) => ({
	type: ALL_PROGRAM_FETCH_FAIL,
	payload: { message }
});

/* Program play */
export const programPlayFetch = (programPlay) => ({
	type: PROGRAM_PLAY_FETCH,
	payload: { programPlay }
});

export const programPlayFetchSuccess = (programPlay) => ({
	type: PROGRAM_PLAY_FETCH_SUCCESS,
	payload: { programPlay }
});

export const programPlayFetchFail = (message) => ({
	type: PROGRAM_PLAY_FETCH_FAIL,
	payload: { message }
});

/* live */
export const liveListFetch = (liveList) => ({
	type: LIVE_FETCH,
	payload: { liveList }
});

export const liveListFetchSuccess = (liveList, liveUserId, liveUserSign) => ({
	type: LIVE_FETCH_SUCCESS,
	payload: { liveList, liveUserId, liveUserSign }
});

export const liveListFetchFail = (message) => ({
	type: LIVE_FETCH_FAIL,
	payload: { message }
});

export const changeoldGroup = (oldGroup) => {
	return (
		{
			type: OLD_GROUP,
			payload: oldGroup
		}
	)
}

/* current play */
export const currentPlayFetch = (currentPlay) => ({
	type: CURRENT_PLAY_FETCH,
	payload: { currentPlay }
});

export const currentPlayFetchSuccess = (currentPlay) => ({
	type: CURRENT_PLAY_FETCH_SUCCESS,
	payload: { currentPlay }
});

export const currentPlayFetchFail = (message) => ({
	type: CURRENT_PLAY_FETCH_FAIL,
	payload: { message }
});


/* program detail */
export const programDetailPreviewFetch = (programDetailPreview) => ({
	type: PROGRAM_DETAIL_PREVIEW_FETCH,
	payload: { programDetailPreview }
});

export const programDetailPreviewFetchSuccess = (programDetailPreview) => ({
	type: PROGRAM_DETAIL_PREVIEW_FETCH_SUCESS,
	payload: { programDetailPreview }
});

export const programDetailPreviewFetchFail = (message) => ({
	type: PROGRAM_DETAIL_PREVIEW_FETCH_FAIL,
	payload: { message }
});



/* program share */
export const programShareFetch = (programShare) => ({
	type: SHARE_FETCH,
	payload: { programShare }
});

export const programShareFetchSuccess = (programShare) => ({
	type: SHARE_FETCH_SUCESS,
	payload: { programShare }
});

export const programShareFetchFail = (message) => ({
	type: SHARE_FETCH_FAIL,
	payload: { message }
});


export const clickProgramShareFetch = (programShare) => ({
	type: CLICK_SHARE_FETCH,
	payload: { programShare }
});

export const clickProgramShareFetchSuccess = (programShare) => ({
	type: CLICK_SHARE_FETCH_SUCESS,
	payload: { programShare }
});

export const clickProgramShareFetchFail = (message) => ({
	type: CLICK_SHARE_FETCH_FAIL,
	payload: { message }
});

